import { CircularProgress, Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { CombinedError } from 'urql/core'

interface FetchingProps {
  queryError?: CombinedError
}

const knownError = (error?: CombinedError) => {
  switch (true) {
    case error?.message.includes?.('hasura cloud limit'):
      return 'Database request limit exceeded'
    case error?.message.includes?.('JWTExpired'):
      return 'Error loading (login expired) - please re-login'
    case error?.message?.includes?.('not found in type'):
      return 'Error loading (permissions not set properly)'
    default:
      return 'Something went wrong!'
  }
}

export const Fetching = ({ queryError }: FetchingProps) => {
  const [isTooLong, setTooLong] = useState(false)
  useEffect(() => {
    const tooLong = setTimeout(() => {
      setTooLong(true)
    }, 30000)
    return () => clearTimeout(tooLong)
  }, [])

  return (
    <Grid
      container
      justifyContent={'center'}
      alignItems={'center'}
      height={'50vh'}
    >
      {isTooLong || queryError ? (
        <Grid item textAlign={'center'}>
          <Typography variant="h2">{knownError(queryError)}</Typography>
          <Typography
            marginTop={'6px'}
            display={'inline-block'}
            textAlign={'center'}
            fontSize={'16px'}
            fontWeight={400}
            lineHeight={'26px'}
            color={'#354967'}
          >
            Please try again later.
          </Typography>
        </Grid>
      ) : (
        <CircularProgress />
      )}
    </Grid>
  )
}
